import { render, staticRenderFns } from "./quotation_info_list.vue?vue&type=template&id=4cd390ed&scoped=true"
import script from "./quotation_info_list.vue?vue&type=script&lang=js"
export * from "./quotation_info_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd390ed",
  null
  
)

export default component.exports